import React, { Component } from "react";

import FileNavigator from "../components/FileNavigator";
import TestNavigator from "../components/TestNavigator";
import {
  Grid,
  Row,
  Col,
} from "react-bootstrap"

import ExerciseApi from "../api/ExerciseApi";

import { Map, List } from "immutable";

import Spinner from "react-spinkit";

let paths = Map();
let fetched = false;
let callbacks = [];
ExerciseApi.getPaths(result => { 
  paths = result; 
  fetched = true;
  callbacks.forEach(callback => callback(paths));
}, error => console.error(error));

function withPaths(callback) {
  if (fetched) {
    callback(paths);
  } else {
    callbacks.push(callback);
  }
}

export default class Exercise extends Component {

  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      paths: null,
      files: Map(),
      changes: List(),
      exampleTest: null,
      demoPath: null,
      hiddenFiles: null,
    }
  }

  componentWillMount() {
    this.update(this.props);
  }

  componentWillReceiveProps(nextProps) {
    this.update(nextProps);
  }

  update = (props) => {
    let files = Map();
    this.setState({loading: true, files: files, changes: List(), exampleTest: null});
    const id = props.match.params.id;
    withPaths(paths => {
      let matchingPaths = paths.get(id);
      matchingPaths.files.forEach(file => {
        files = files.set(file, "");
      });
      ExerciseApi.getMetadata(id, "default", metadata => {
        this.setState({exampleTest: metadata.test, hiddenFiles: metadata.hiddenFiles});
      });
      ExerciseApi.getContent(files, id, "default", filesWithContent => {
        this.setState({files: filesWithContent, loading: false});
      }, error => console.error(error));   
      let demoPath = null;
      if (matchingPaths.files.some(file => file === "demo.html")) {
        demoPath = "https://s3.amazonaws.com/exercise.whyyoushouldstoptesting.com/"+id+"/default/demo.html";
      }
      this.setState({demoPath: demoPath});
      matchingPaths.changes.keySeq().forEach(key => {
        let filenames = matchingPaths.changes.get(key);
        let filesWithoutContent = Map();
        filenames.forEach(filename => {
          filesWithoutContent = filesWithoutContent.set(filename, "");
        })
        ExerciseApi.getContent(filesWithoutContent, id, key, filesWithContent => {
          if (filesWithContent.some((content, filename) => content === "" && filename.endsWith(".js"))) {
            return;
          }
          ExerciseApi.getMetadata(id, key, metadata => {
            let updatedChanges = this.state.changes.push({
              name: metadata.name,
              failMessage: metadata.failMessage,
              shouldFail: metadata.shouldFail,
              files: filesWithContent
            });
            this.setState({changes: updatedChanges});
          });
        });
      });
    });
  }

  render() {
    let files = [];

    this.state.files.forEach((content, filename) => {
      files.push({
        filename: filename,
        content: content
      });
    });

    return (
      
      <Grid fluid={true}>
        {this.state.loading && 
        <Spinner name='three-bounce'/>
        }
        {!this.state.loading &&
        <Row>
          <Col sm={6}>
            <FileNavigator files={files} demoPath={this.state.demoPath} hiddenFiles={this.state.hiddenFiles}/>
          </Col>
          <Col sm={6}>
            <TestNavigator exerciseId={this.props.match.params.id}
              files={files}
              changes={this.state.changes}
              exampleTest={this.state.exampleTest}
              hiddenFiles={this.state.hiddenFiles} />
          </Col>
        </Row>
        }
      </Grid>
    );
  }
}


// WEBPACK FOOTER //
// ./src/pages/exercise.js